/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { Box, Tooltip, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

import React from "react";

import CloseIcon from "@mui/icons-material/Close";

import { IconButton } from "@mui/material";
import { ModalBase } from "../../utils/Interfaces";
import { useWindowDimensions } from "../../utils/Hooks";

export interface PreviewModalProps extends ModalBase {
    mediaUrl: string;
    fileName: string;
}

const PreviewModal = (props: PreviewModalProps) => {
    const { mediaUrl, fileName, open, handleClose } = props;

    const { width } = useWindowDimensions();
    const mobile = width <= 600;

    return (
        <Modal
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
            }}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        minWidth: mobile ? "100vw" : "400px",
                        maxWidth: mobile ? "100vw" : "80vw",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", pt: 1, pl: 2 }}>
                            <Typography variant="h6">{fileName}</Typography>
                            <Box sx={{ position: "absolute", top: 0, right: 0 }}>
                                <Tooltip title="Close">
                                    <IconButton onClick={() => handleClose()} size="large">
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        <img alt="User uploaded content" src={mediaUrl} style={{ maxHeight: "80vh", padding: 12 }} />
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};

export default PreviewModal;
